<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <StaticInfosForm :baseStaticInfo="staticInfo" :baseStaticInfoTitle="title" :loading="loading" @submit-requested="submitRequested"></StaticInfosForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StaticInfosForm from './StaticInfosForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            staticInfo: null,
            title: this.$route.params.title,
            loading: true
        }
    },
    components: { StaticInfosForm },
    computed:
    {
        ...mapState('staticInfos', ['getStaticInfoDetailsOutput']),
    },
    methods: {
        ...mapActions('staticInfos', ['getStaticInfoDetails']),
        ...mapActions('staticInfos', ['putStaticInfo']),
        submitRequested(staticInfo) {
            this.putStaticInfo(staticInfo);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'StaticInfosList' });
        }

        this.getStaticInfoDetails(this.$route.query.id);
    },
    watch:
    {
        getStaticInfoDetailsOutput: function(staticInfoOutput)
        {
            if(!staticInfoOutput && !staticInfoOutput.data)
            {
                router.push({ name: 'StaticInfosList' });
            }
            else
            {
                this.staticInfo = staticInfoOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>